"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: "1",
  title: "Maison Jas",
  description: "Ein Rückzugsort hoch in den Schweizer Alpen, umgeben von unberührter Natur und absoluter Stille. Ideal für tiefe Reflexion, emotionale Klarheit und Abstand vom Alltag.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/08/IMG_9980-scaled.jpg",
  className: "md:col-span-2 md:row-span-2"
}, {
  id: "2",
  title: "Lavendelfelder",
  description: "Sanfte Lavendeltöne und der beruhigende Duft der Natur unterstützen den Prozess der emotionalen Klärung und Entspannung. Ein Ort, um neue Energie zu tanken.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/04/IMG_8512-scaled.jpg?v=xx2xggi9huk",
  className: "md:col-span-1 md:row-span-2"
}, {
  id: "3",
  title: "Meditationsraum",
  description: "Klar strukturiert, lichtdurchflutet und minimalistisch eingerichtet. Ein Raum, der den Geist zur Ruhe kommen lässt und geerdetes spirituelles Wachstum fördert.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/04/IMG_8520-scaled.jpg?v=afg44j4nw0q",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "4",
  title: "Naturverbundenheit",
  description: "Die direkte Verbindung zur Natur ist ein zentraler Bestandteil unserer Healing Retreats. Sie bietet den perfekten Rahmen für innere Entwicklung.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/04/IMG_9373-scaled.jpg?v=z7nxfp3bg3",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "5",
  title: "Innere Einkehr",
  description: "Eine warme, vertrauensvolle Atmosphäre, die professionelle Begleitung und authentische Unterstützung auf deinem Weg der persönlichen Transformation ermöglicht.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/08/44bad1d3-56d6-4291-862f-78be07fee910.jpg?v=9vgizwymf7k",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "6",
  title: "Lavendelduft",
  description: "Die weiten Felder der Provence bieten eine unvergleichliche Kulisse für tiefe Entspannung und das Loslassen alter Muster.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/04/IMG_9428-scaled.jpg?v=nyv9042hd2j",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "7",
  title: "provenzialische Orte",
  description: "Momente der absoluten Ruhe ermöglichen es, die eigene innere Stimme wieder klar und deutlich wahrzunehmen.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/08/IMG_0171-scaled.jpg?v=4roiurw0nt",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "8",
  title: "Markt in der Provence",
  description: "Sanfte akustische Untermalung und die Stille der Natur verschmelzen zu einer heilenden Symphonie für Körper und Geist.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/08/IMG_0098-scaled.jpg?v=el2ltjfz3d6",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "9",
  title: "Paradies",
  description: "Die Frische des Morgens in den Bergen weckt die Lebensgeister und schenkt einen klaren Fokus für den beginnenden Tag der Transformation.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/04/IMG_9356-scaled.jpg?v=45xgj24jtt2",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "10",
  title: "Abendstille",
  description: "Wenn die Sonne hinter den Gipfeln versinkt, kehrt eine tiefe, heilende Ruhe ein, die Raum für Integration und inneren Frieden schafft.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/08/IMG_9984-scaled.jpg?v=mpr1kpe73so",
  className: "md:col-span-1 md:row-span-1"
}, {
  id: "11",
  title: "Kraftort Natur",
  description: "Inmitten der unberührten Landschaft finden wir zurück zu unseren Wurzeln und entdecken die unerschöpfliche Kraftquelle in unserem Inneren.",
  image: "https://wandelherz.ch/wp-content/uploads/2026/08/IMG_0276-scaled.jpg?v=nonberbpw88",
  className: "md:col-span-1 md:row-span-1"
}];
export default function RoomsOfSilence() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="räume-der-stille" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-primary/80 uppercase tracking-widest text-sm font-medium mb-4 block">Wandelherz Retreats</span>
          <h2 className="font-serif text-5xl md:text-7xl text-foreground tracking-tight mb-6">
            Räume der Stille
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl font-light leading-relaxed">Entdecke einen Ort der absoluten Klarheit und Ruhe. Meine zukünftigen Healing Retreats in Südfrankreich in der wunderschönen Provence bieten den perfekten Rahmen für deine persönliche körperliche und energetische Transformation. Dank Yoga und Meditation.</p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 auto-rows-[300px] md:auto-rows-[400px] transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className={`group relative overflow-hidden rounded-xl bg-muted ${item.className}`}>
              <img src={item.image} alt={i === 0 ? "Maison Jas" : item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
              <div className="absolute inset-0 bg-black/20 transition-opacity duration-500 group-hover:bg-black/40" />
              
              <div className="absolute inset-0 p-8 flex flex-col justify-end opacity-0 translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                <div className="flex items-center justify-between text-white">
                  <h3 className="font-serif text-2xl md:text-3xl">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}